import "legacy/user_registration"
import "legacy/international_delivery"

require.context('legacy/images', true, /\.(gif|jpg|png|svg)$/i)
